import { makeStyles } from '@mui/styles'

const useStyles = makeStyles(theme => ({
  completeInfo: {
    '& .MuiListItem-root': {
      backgroundColor: theme.palette.neutral.lightest,
    },

    '& .MuiListItemIcon-root svg': {
      height: theme.spacing(3),
      width: theme.spacing(3),
    },

    '& .MuiListItemIcon-root': {
      marginTop: theme.spacing(0),
      color: theme.palette.neutral.light,
    },

    '& .MuiListItemText-primary': {
      ...theme.typography.inputText,
      color: theme.palette.neutral.dark,
    },
    '& .MuiListItemText-secondary': {
      ...theme.typography.body1,
      color: theme.palette.neutral.main,
    },
  },

  info: {
    '& .MuiListItemIcon-root': {
      marginTop: theme.spacing(0),
      '& svg': {
        height: theme.spacing(3),
        width: theme.spacing(3),
        color: theme.palette.neutral.light,
      },
    },

    '& .MuiListItemText-primary': {
      ...theme.typography.label,
      color: theme.palette.neutral.main,
    },
    '& .MuiListItemText-secondary': {
      ...theme.typography.inputText,
      color: theme.palette.neutral.dark,
    },
  },

  secondaryItem: {
    ...theme.typography.body2,
    color: theme.palette.neutral.dark,
    paddingRight: theme.spacing(1),
  },
  error: {
    '& .MuiListItem-root': {
      backgroundColor: theme.palette.error.light,
    },

    '& .MuiListItemIcon-root svg, &$info .MuiListItemText-secondary': {
      color: theme.palette.error.dark,
    },
  },

  // TODO: use typography instead of alert?
  alert: {
    padding: theme.spacing(1),
    background: 'transparent',

    '& .MuiAlert-message': {
      padding: theme.spacing(0.5),
    },

    '& .MuiAlert-icon': {
      opacity: 0,
    },
  },
}))

export default useStyles
